module.exports = __webpack_public_path__ + "img/certificate_020332410_00.571e8fd0.jpg";